export const NAVIGATION_FETCH_CONFIG = 'navigation.fetch-config';
export const NAVIGATION_SET_CONFIG = 'navigation.set-config';
export const NAVIGATION_CLEAR_CONFIG = 'navigation.clear-config';
